'use strict';

exports.__esModule = true;
exports.CLOSE_BUTTON_TONES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

var _CloseButtonStyled = require('./CloseButtonStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// React-Wrapper-Pflichtmuster (wie Card.jsx): reicht `className` durch, damit
// Konsumenten via styled(CloseButton) ihr Layout ergaenzen koennen, und
// forwardRef, damit styled(CloseButton) eine ref durchreichen kann. Rendert ein
// echtes <button type="button"> — behebt damit den A11y-Bug der frueheren
// styled.div-Variante (EventMoreCloseButton war ein nicht-fokussierbares DIV).
var CLOSE_BUTTON_TONES = exports.CLOSE_BUTTON_TONES = { SECONDARY: 'secondary' };

var CloseButton = _react2.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      top = _ref.top,
      right = _ref.right,
      size = _ref.size,
      tone = _ref.tone,
      zIndex = _ref.zIndex,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ['className', 'top', 'right', 'size', 'tone', 'zIndex', 'ariaLabel', 'onClick', 'type']);

  return _react2.default.createElement(
    _CloseButtonStyled.CloseButtonStyled,
    _extends({
      ref: ref,
      className: className,
      type: type,
      top: top,
      right: right,
      size: size,
      tone: tone,
      zIndex: zIndex,
      'aria-label': ariaLabel,
      onClick: onClick
    }, rest),
    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faTimes })
  );
});

CloseButton.propTypes = {
  className: _propTypes2.default.string,
  top: _propTypes2.default.string,
  right: _propTypes2.default.string,
  size: _propTypes2.default.number,
  tone: _propTypes2.default.oneOf(Object.values(CLOSE_BUTTON_TONES)),
  zIndex: _propTypes2.default.number,
  ariaLabel: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  type: _propTypes2.default.string
};

CloseButton.defaultProps = {
  className: undefined,
  top: undefined,
  right: undefined,
  size: 25,
  tone: CLOSE_BUTTON_TONES.SECONDARY,
  zIndex: undefined,
  ariaLabel: 'Close',
  onClick: undefined,
  type: 'button'
};

exports.default = CloseButton;